export { default as GoogleAnalytics, trackEvent } from './GoogleAnalytics'; 